import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How often should I have my lawn mowed?",
    answer: "We offer a fixed weekly mowing schedule. We recommend this for the best results—consistent weekly mowing keeps your lawn at optimal height and promotes healthier growth throughout the season."
  },
  {
    question: "Do you offer free estimates?",
    answer: "Yes! We provide free, no-obligation estimates for all our services. You can schedule online or call us at (763) 245-7813 to set up a convenient time for your property assessment."
  },
  {
    question: "Are you insured?",
    answer: "Absolutely. Riekels Lawn Care & Landscaping is fully insured with comprehensive liability coverage. We take every precaution to protect your property and our team."
  },
  {
    question: "What areas do you serve?",
    answer: "We proudly serve Maple Grove, Plymouth, Rogers, Medina, Corcoran, and surrounding West Twin Cities Metro communities."
  },
  {
    question: "When should I aerate my lawn?",
    answer: "For cool-season grasses in Minnesota, fall is the ideal time for aeration and overseeding. We recommend aerating once per year during August through October."
  },
  {
    question: "What's included in your lawn care packages?",
    answer: "Our lawn care packages typically include mowing, edging, trimming, and blowing. We also offer add-on services like aeration, dethatching, and seasonal cleanups. Contact us for a customized program that fits your needs and budget."
  },
  {
    question: "Do you offer snow removal services?",
    answer: "Yes, we provide residential and commercial snow removal services throughout the winter season. We offer seasonal contracts for reliable, priority service whenever it snows."
  },
  {
    question: "How do I prepare my lawn for winter?",
    answer: "We recommend a fall cleanup including leaf removal and a final mow at a lower height. Our fall cleanup services will prepare your lawn to thrive when spring arrives."
  },
];

export const HomeFAQ = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="section-badge">Got Questions?</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mt-4 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Find answers to common questions about our lawn care and landscaping services.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-xl px-6 data-[state=open]:border-secondary"
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-foreground hover:text-secondary py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
